import React, { useState, useEffect, Fragment, useRef } from 'react';
import { Table } from '@digital/ui';
import ptBr from '@app/i18n/ptBR/index';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HC_exporting from 'highcharts/modules/exporting';
import { AreaExecutiveSummaryTipoProjetoForecastResult } from '@app/api/areaExecutiveSummary';

export interface AreaExecutiveSummaryTipoProjetoForecastProps {
  graficoResult: AreaExecutiveSummaryTipoProjetoForecastResult;
}

const AreaExecutiveSummaryTipoProjetoForecast = ({ graficoResult }: AreaExecutiveSummaryTipoProjetoForecastProps) => {
  
  const chartRef = useRef(null);
  const optionsColumn: Highcharts.Options = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie'
    },
    title: {
      text: '',
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.2f}%</b>',
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
    }   
    plotOptions: {
      pie: {
        showInLegend: true,
        allowPointSelect: true,
        shadow: false,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.2f}%'
        },
      },
    },
    colors: ['#08340D', '#E1865C', '#8C0400', '#006129', '#FFA357', '#80BDA6', '#08340D', '#E1865C'],
    series: [
      {
        name: 'Brands',
        colorByPoint: true,
        data: graficoResult && graficoResult.series ? graficoResult.series : [],
      },
    ],
  };

  useEffect(() => { }, []);
  return (
    <>
      <HighchartsReact ref={chartRef} highcharts={Highcharts} options={optionsColumn} />
    </>
  );
};

export default AreaExecutiveSummaryTipoProjetoForecast;
